import { useEffect, useState } from 'react'
import { useAppDispatch } from '../hooks/store-hooks'

export const usePersistentState = (key: string, initialValue: any) => {
  const dispatch = useAppDispatch()
  const [state, setstate] = useState(() => {
    try {
      const storedValue = sessionStorage.getItem(key)
      return storedValue ? JSON.parse(storedValue) : initialValue
    } catch (error) {
      console.error('Error reading sessionStorage:', error)
      return initialValue
    }
  })

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state))
    } catch (error) {
      console.error('Error writing to sessionStorage:', error)
    }
  }, [dispatch, key, state])

  return [state, setstate]
}
